import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(
    public http: HttpClient
  ) { }

  getClientes(cedula){
    return new Promise((resolve, reject) => {
      this.http.get("https://www.klixinternet.com/servicios-klix/public/api/klix/clientes/getServicios/"+cedula).subscribe(
        (data: Response) => {
          resolve(data);
        },
        (err) => {
          reject(err);
        }
      )
    })
  }

}
